import {
    isInternational
} from '../global/_checkForInternational';

const clearFilters = () => {
    if ($('#mobileFilterSelected').length > 0) {
        $('#mobileFilterSelected, #ghostDiv').removeClass('active');
        $('#filterCount').data('count', 0);
        $('#selectedFilterWrapper, #filterCount, #filterCountResults').html('');
    }
};

const removeMobileCrumb = (current) => {
    if (!window.dragging) {
        var facetID = current.attr('id').split('selectedFilter')[1];
        current.remove();
        $(`#${facetID}`).trigger('click');
    }
}

const mobileFilterCrumbs = () => {
    if ($('.wrapper-product-results').length > 0) {
        $('#selectedFilterWrapper').on('touchstart', '.selectedFilter', function() {
            window.dragging=false;
        }).on('touchmove', '.selectedFilter', function() {
            window.dragging=true;
        }).on('touchend', '.selectedFilter', function() {
            removeMobileCrumb($(this));
        });
        const updateFilter = (facetID) => {
            let facetTitle = $(`#${facetID}`).siblings('span').data('twist');
            if (facetTitle !== undefined && !$('#selectedFilter' + facetID).length > 0) {
                $('#selectedFilterWrapper').append(`<div class="selectedFilter" id="selectedFilter${facetID}"><span class="selectedFilter--title">${facetTitle}</span><span class="remove-filter">×</span></div>`);
                if (!$('#mobileFilterSelected, #ghostDiv').hasClass('active')) $('#mobileFilterSelected, #ghostDiv').addClass('active');
            }
        };

        const loadMobileCrumbs = (url_facetGrab) => {
            var filterCount = 0;
            // If there is more than one filter selected
            if (url_facetGrab.indexOf('|') > -1) {
                $.each(url_facetGrab.split('|'), function (i, facetID) {
                    updateFilter(facetID);
                    filterCount = i + 1;
                });
                // This is an Internet Explorer issue where | are converted to %7C
            } else if (url_facetGrab.indexOf('%7C') > -1) {
                $.each(url_facetGrab.split('%7C'), function (i, facetID) {
                    updateFilter(facetID);
                    filterCount = i + 1;
                });
                // If there is only one filter selected
            } else {
                updateFilter(url_facetGrab);
                filterCount = 1
            }
            $('#filterCount').data('count', filterCount).html(`(${filterCount})`);
            $('#filterCountResults').html(` (${filterCount})`);
        };

        let url = window.location.href,
            appliedFacet = url.indexOf('&facet=') > -1,
            appliedFacet_sales = url.indexOf('#facet=') > -1,
            newArrivals = url.indexOf('1000149') > -1;
        // If there are filters selected
        if (!isInternational() && (appliedFacet || appliedFacet_sales)) {
            // Grab the selected filters
            let url_facetGrab = (url.indexOf('&facet=') > -1) ? url.split('&facet=')[1] : (url.indexOf('#facet=') > -1) ? url.split('#facet=')[1] : '';
            loadMobileCrumbs(url_facetGrab);
        } else if (isInternational() && (url.indexOf('&facet=-') > -1 || url.indexOf('#facet=-') > -1 || newArrivals)) {
            // Grab the selected filters
            let url_facetGrab = (url.indexOf('&facet=-') > -1) ? `-${url.split('&facet=-')[1]}` : newArrivals ? `1000149${url.split('1000149')[1]}` : '';
            loadMobileCrumbs(url_facetGrab);
        }

        // Prevent Unwanted Clearing of filters
        window.dragging = false;
    }
}

export {
    clearFilters,
    mobileFilterCrumbs,
    removeMobileCrumb
}